exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-video {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.card-video > a {\n  flex-grow: 1;\n}\n.card-article__image_holder {\n  display: block;\n  width: 100%;\n  height: 180px;\n  overflow: hidden;\n  border-radius: 15px 15px 0 0;\n}", ""]);

// exports
